module.exports = __webpack_public_path__ + "img/bandera_reino_unido.cb685003.svg";